import { Button } from 'antd';
import paths from './../../../paths';
import { useTranslate } from '@above-the-treeline/localization';

export default function BackToHomeButton({
	className = 'back-to-home-button',
}): JSX.Element {
	const { translate } = useTranslate();
	const handleClick = (): void => {
		window.location.href = paths.home();
	};

	return (
		<Button
			onClick={handleClick}
			type="primary"
			className={`orange-ant-btn ${className}`}>
			{translate ? translate('back_to_home') : 'Back to Home'}
		</Button>
	);
}
